package pl.michal_cyran.brand_hub.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import pl.michal_cyran.brand_hub.components.layouts.PageLayoutData
import pl.michal_cyran.brand_hub.pages.utils.PageContent
import pl.michal_cyran.brand_hub.subpages.tutoring.sections.TutoringAboutMe
import pl.michal_cyran.brand_hub.subpages.tutoring.sections.TutoringLessons
import pl.michal_cyran.brand_hub.subpages.tutoring.sections.TutoringHero
import pl.michal_cyran.brand_hub.subpages.tutoring.sections.TutoringOffer
import pl.michal_cyran.brand_hub.subpages.tutoring.sections.TutoringPrice
import pl.michal_cyran.brand_hub.subpages.tutoring.sections.TutoringTestimonials

@InitRoute
fun initTutoringPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Korepetycje"))
}


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun TutoringPage() {
    Column(
        modifier = Modifier
            .fillMaxSize()
    ) {
        PageContent(
            { TutoringHero() },
            { TutoringAboutMe() },
            { TutoringLessons() },
            { TutoringOffer() },
            { TutoringTestimonials() },
            { TutoringPrice() },
        )
    }
}
